export enum AUTO_GAME_TYPES {
    BingoRoom = 'BINGOROOM'
}

export enum GAME_LAUNCH_TYPE {
    Casino = 'Casino',
    BingoRoom = 'BingoRoom',
    Default = 'Default'
}
